// User types
export interface User {
  uid: string;
  email: string | null;
  displayName: string | null;
}

// Month names
export type MonthName = 'Jan' | 'Feb' | 'Mar' | 'Apr' | 'May' | 'Jun' | 
                        'Jul' | 'Aug' | 'Sep' | 'Oct' | 'Nov' | 'Dec';

// Transaction types
export interface Transaction {
  id: string;
  type: 'gain' | 'expense';
  name: string;
  amount: number;
  categoryId: string;
  date: Date;
  notes?: string;
  createdAt: Date;
  // Recurring transaction fields
  isRecurring?: boolean;
  recurringTemplateId?: string;
}

// Transaction input type (for creating new transactions)
export interface TransactionInput {
  name: string;
  amount: number;
  type: 'gain' | 'expense';
  categoryId: string;
  date: Date;
  notes?: string;
  isRecurring?: boolean;
  recurringTemplateId?: string;
}

// Month data
export interface MonthData {
  salary: number;
  totalGains: number;
  totalExpenses: number;
  savings: number;
  transactions: Transaction[];
}

// User settings - UPDATED with defaultMonthlySalary and displayCurrency
export interface UserSettings {
  currency: 'USD' | 'EUR' | 'MGA' | 'GBP' | 'JPY' | 'INR'; // Account/Main currency
  displayCurrency?: 'USD' | 'EUR' | 'MGA' | 'GBP' | 'JPY' | 'INR'; // Optional display currency for conversion
  language: 'en' | 'fr';
  theme: 'dark' | 'light' | 'system';
  yearlyGoal: number;
  defaultMonthlySalary: number;
}

// Category types
export interface Category {
  id: string;
  name: string;
  type: 'gain' | 'expense';
  color: string;
}

// Gain categories (from your Python app)
export const GAIN_CATEGORIES: Record<string, { en: string; fr: string }> = {
  gain_1: { en: 'Part-time Job', fr: 'Travail à temps partiel' },
  gain_2: { en: 'Overtime Pay', fr: 'Heures supplémentaires' },
  gain_3: { en: 'Bonuses or Commissions', fr: 'Bonus ou commissions' },
  gain_4: { en: 'Consulting or Contract Work', fr: 'Conseil ou contrat' },
  gain_5: { en: 'Tips', fr: 'Pourboires' },
  gain_6: { en: 'Online Work', fr: 'Travail en ligne' },
  gain_7: { en: 'Scholarships or Stipends', fr: 'Bourses ou allocations' },
  gain_8: { en: 'Other Income', fr: 'Autres revenus' },
};

// Expense categories (from your Python app)
export const EXPENSE_CATEGORIES: Record<string, { en: string; fr: string }> = {
  exp_1: { en: 'Utilities', fr: 'Services publics' },
  exp_2: { en: 'Internet', fr: 'Internet' },
  exp_3: { en: 'Mobile Phone', fr: 'Téléphone mobile' },
  exp_4: { en: 'Insurance', fr: 'Assurance' },
  exp_5: { en: 'Loan Repayments', fr: 'Remboursements de prêt' },
  exp_6: { en: 'Subscriptions', fr: 'Abonnements' },
  exp_7: { en: 'Transportation', fr: 'Transport' },
  exp_8: { en: 'Food', fr: 'Nourriture' },
  exp_9: { en: 'Rent', fr: 'Loyer' },
  exp_10: { en: 'Other Expenses', fr: 'Autres dépenses' },
};

// Currency symbols
export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  EUR: '€',
  MGA: 'Ar',
  GBP: '£',
  JPY: '¥',
  INR: '₹',
};